<template>
  <!-- CONTENT -->
  <vx-card>
    <div class="content-container">
      <!-- HEAD -->
      <div class="py-2 sticky" style="top: 80px; background-color: #fff; z-index: 10">
        <div class="flex items-center justify-start gap-2 mb-3">
          <vs-select autocomplete v-model="nav.perPage" style="width: 140px">
            <vs-select-item v-for="_perPage in perPageOpstions" :key="`perpage_${_perPage}`" :text="_perPage === -1 ? '전체 보기' : `${_perPage}개씩 보기`" :value="_perPage" />
          </vs-select>
          <filter-module
            :filter-keys="['시설구분', '보관자', '관리방법', '소관부서', '담당주무관']"
            :filter-types="['multi-select', 'input', 'multi-select', 'input', 'input']"
            :filter-value-options="{
              시설구분: this.filterCodeName,
              관리방법: ['직접관리', '위탁관리'],
            }"
            :value="nav.filter"
            @input="filterButtonInput"
          >
          </filter-module>
          <SearchNavItemKeyword :viewLabel="true" label="" v-model="nav.searchKeyword" class="ml-auto" @keyupEvent="handleKeywordSearch" />
        </div>
        <div v-if="editMode" class="flex items-center justify-between gap-2 mb-3">
          <div class="flex items-center gap-2">
            <h5 class="mr-2">선택 게시글 순서변경</h5>

            <vs-button :disabled="checkList.length === 0" class="px-2 py-2 m-0" color="secondary" type="border" @click="checkList = []"> 전체 해제 {{ checkList.length > 0 ? `(${checkList.length})` : "" }} </vs-button>

            <vs-button :disabled="checkList.length === 0" class="px-2 py-1 m-0" color="secondary" type="border" @click="moveTop">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4459_33082)">
                  <path d="M14.166 15L9.99935 10.8333L5.83268 15L14.166 15Z" fill="currentColor" />
                  <path d="M14.166 9.16699L9.99935 5.00032L5.83268 9.16699L14.166 9.16699Z" fill="currentColor" />
                </g>
                <defs>
                  <clipPath id="clip0_4459_33082">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </vs-button>

            <vs-button :disabled="checkList.length === 0" class="px-2 py-1 m-0" color="secondary" type="border" @click="moveUp">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4459_35683)">
                  <path d="M5.83398 11.6667L10.0007 7.5L14.1673 11.6667H5.83398Z" fill="currentColor" />
                </g>
                <defs>
                  <clipPath id="clip0_4459_35683">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </vs-button>

            <vs-button :disabled="checkList.length === 0" class="px-2 py-1 m-0" color="secondary" type="border" @click="moveDown">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4459_33091)">
                  <path d="M5.83398 8.3335L10.0007 12.5002L14.1673 8.3335H5.83398Z" fill="currentColor" />
                </g>
                <defs>
                  <clipPath id="clip0_4459_33091">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </vs-button>

            <vs-button :disabled="checkList.length === 0" class="px-2 py-1 m-0" color="secondary" type="border" @click="moveBottom">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4459_18711)">
                  <path d="M5.83398 5L10.0007 9.16667L14.1673 5L5.83398 5Z" fill="currentColor" />
                  <path d="M5.83398 10.833L10.0007 14.9997L14.1673 10.833L5.83398 10.833Z" fill="currentColor" />
                </g>
                <defs>
                  <clipPath id="clip0_4459_18711">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </vs-button>
          </div>

          <div class="flex items-center justify-end gap-2">
            <vs-button v-if="isAdmin" color="secondary" @click="resetOverByData">순서초기화</vs-button>
            <vs-button v-if="isAdmin" color="secondary" type="border" @click="cancelOverByData">편집취소</vs-button>
            <vs-button v-if="isAdmin" color="secondary" @click="saveOverByData">편집저장</vs-button>
          </div>
        </div>
        <div v-else class="flex items-center justify-between gap-2 mb-3">
          <h5 class="pt-2 pb-4">대상수 : {{ tableData.length }}개소</h5>
          <div class="flex items-center justify-end gap-2">
            <vs-button class="py-0 pl-6" color="secondary" type="border" @click="onClickPrint">
              <div class="flex items-center">
                <feather-icon icon="PrinterIcon" svgClasses="h-6 w-6" class="mr-1" />
                <span class="my-3">인쇄</span>
              </div>
            </vs-button>
            <vs-button class="py-0 pl-6" color="secondary" type="border" @click="openExcelPopup">
              <div class="flex items-center">
                <feather-icon icon="DownloadIcon" svgClasses="h-6 w-6" class="mr-1" />
                <span class="my-3">엑셀 다운로드</span>
              </div>
            </vs-button>
            <vs-button v-if="isAdmin" color="secondary" type="border" @click="editMode = true">순서편집</vs-button>
          </div>
        </div>
      </div>

      <!-- TABLE -->
      <div id="print-report">
        <table>
          <colgroup>
            <col width="60px" />
            <col width="140px" />
            <col width="100px" />
            <col width="100px" />
          </colgroup>
          <thead>
            <tr>
              <th v-if="editMode">선택({{ checkList.length }})</th>
              <th>연번</th>
              <th>소관부서</th>
              <th>담당자</th>
              <th>구분</th>
              <th>시설구분</th>
              <th>시설명</th>
              <th>시설위치(사업장주소)</th>
              <th>관리방법</th>
              <th>면적(㎡), 형식, 연장,<br />차로수, 높이 등</th>
              <!-- <th>적용제외대상</th> -->
              <th>비고</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, row_i) in renderTableData" :key="row_i" @click="handleRowClick(row)" class="cursor-pointer" :class="checkList.includes(row.id) ? 'active' : ''">
              <td v-if="editMode">
                <div class="flex items-center justify-center">
                  <vs-checkbox class="p-0 m-0" :value="checkList" :vs-value="row.id" />
                </div>
              </td>
              <td>{{ row.oldOrderByNumber }}</td>
              <td>{{ row.소관부서 }}</td>
              <td>{{ row.담당주무관 }}</td>
              <td>{{ row.분류 }}</td>
              <td>{{ row.시설구분 }}</td>
              <td>{{ row.시설물명 }}</td>
              <td>{{ row.주소 }}</td>
              <td>{{ row.관리방법 }}</td>
              <td>{{ row.면적형식연장등 }}</td>
              <!-- <td>{{ row.적용제외대상 }}</td> -->
              <td>{{ row.비고 }}</td>
            </tr>
            <tr v-if="renderTableData.length === 0">
              <td :colspan="nav.currentTab === 'all' ? 10 + (editMode ? 1 : 0) : 7 + (editMode ? 1 : 0)">표시할 데이터가 없습니다.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PAGINATION -->
      <div class="vs-con-table mt-10">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="nav.total" :perPage="nav.perPage" :max-items="5" v-model="nav.currentPage"></k-pagination>
        </div>
      </div>
    </div>

    <popup-excel-download v-model="showExcelPopup" :list="excelList" title="소관 시설 현황" />
  </vx-card>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import KPagination from "@/components/kPagination/kPagination";
import moment from "moment";
import FilterModule from "./FilterModule.vue";
import idb from "@/util/IndexDbUtil";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";

export default {
  components: {
    PopupExcelDownload,
    FilterModule,
    SearchNav,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    KPagination,
  },
  data() {
    return {
      nav: {
        currentTab: "all",

        created_at: "",
        searchYear: moment().format("YYYY"),
        searchType: "",
        searchTypeFilter: "",
        searchKeyword: "",

        filter: [{ key: "시설구분", value: ["전체"] }],

        perPage: -1,
        currentPage: 1,
        total: 0,
      },
      orderByBoardId: 1096, // 순서변경용 게시판 ID
      orderByPostId: null, // 순서변경용 게시글 ID
      orderByList: [], // 순서변경용 리스트

      apiData: [], // api 호출로 받아온 데이터
      tableData: [], // 필터 적용 후 데이터
      renderTableData: [], // 페이징처리되어 화면에 표기될 데이터
      cacheData: null, // 캐시된 데이터
      cacheDuration: 60 * 60 * 1000, // 1시간 (밀리초)
      editMode: false, // 편집모드
      checkList: [],

      showExcelPopup: false,
      excelList: [],

      공중이용시설Codes: {
        도서관: "library",
        "박물관 및 미술관": "museum",
        의료기관: "medical",
        어린이집: "daycare",
        업무시설: "office",
        실내공연장: "indoor-auditorium",
        둘이상용도건축물: "mixed-use-building",
        건축물: "building",
        "항만(방파제)": "port",
        "항만(부두)": "port-dock",
        교량: "bridge",
        터널: "tunnel",
        옹벽: "retaining-wall",
        절토사면: "cutting-slope",
        제방: "dike",
        소규모수도: "waterworks",
        청사: "government-building",
        복합시설: "complex-facility",
        하수도: "sewage-treatment",
        상수도: "water-supply",
        실내체육시설: "indoor-sports-facility",
      },
      원료제조물Codes: {
        급식소: "mass_feeding_facility",
        먹는물: "drinking-water",
        승강기: "lift",
        식품제조가공업: "food-processing",
        "어린이 놀이시설": "kids-play-area",
      },
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    perPageOpstions() {
      return [-1, 10, 20, 50, 75, 100, 125, 150];
    },
    filterCodeName() {
      return Object.keys(this.codes);
    },
    searchFieldCodes() {
      const codes = this.codes;
      if (this.nav.filter.length === 0) {
        return Object.values(codes);
      }

      const selectCodes = [];
      if (this.nav.filter.length > 0) {
        for (const filter of this.nav.filter) {
          if (filter.key === "시설구분") {
            if (filter.value.includes("전체")) {
              for (const key in codes) {
                if (!selectCodes.includes(codes[key])) {
                  selectCodes.push(codes[key]);
                }
              }
            } else if (filter.value.length > 0) {
              for (const value of filter.value) {
                if (codes[value] && !selectCodes.includes(codes[value])) {
                  selectCodes.push(codes[value]);
                }
              }
            }
          } else {
            for (const key in codes) {
              if (!selectCodes.includes(codes[key])) {
                selectCodes.push(codes[key]);
              }
            }
          }
        }
      }
      return selectCodes;
    },
    codes() {
      const codes = {
        ...this.공중이용시설Codes,
        ...this.원료제조물Codes,
      };
      return codes;
    },

    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
  },
  watch: {
    "nav.searchKeyword"() {
      this.checkList = [];
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setTableData();
    },
    "nav.perPage"() {
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    "nav.currentPage"() {
      this.setRenderTableData();
    },
    "nav.searchYear"() {
      this.$set(this.nav, "currentPage", 1);
      this.loadAPI();
    },
  },
  async mounted() {
    await this.loadOrderByAPI();
    await this.loadAPI();
  },
  beforeDestroy() {
    // 메모리 정리 (로컬 스토리지 캐시는 유지)
    this.cacheData = null;
  },
  methods: {
    // 검색 버튼 클릭
    handleClickSearch() {
      this.setTableData();
    },
    // 키워드 검색 처리
    handleKeywordSearch() {
      this.nav.currentPage = 1;
      this.checkList = [];
      this.setTableData();
    },

    printLandscape() {
      this.print("@media print {@page { size: a3 landscape; margin: 1cm; }}");
    },
    printPortrait() {
      this.print("@media print {@page { size: a3 portrait; margin: 1cm; }}");
    },
    print(css) {
      // 프린트
      this.isPrint = true;

      setTimeout(() => {
        const printTextarea = document.getElementsByClassName("print-textarea");
        for (let i = 0; i < printTextarea.length; i++) {
          const pt_r = printTextarea[i].innerHTML.trimStart().trimEnd().replace(/\r\n/gi, "<br>").replace(/\\n/gi, "<br>").replace(/\n/gi, "<br>");

          document.getElementsByClassName("print-textarea")[i].innerHTML = pt_r;
        }

        const hidePrintTitleEl = document.getElementById("hidePrintTitle");
        const hidePrintTitle = hidePrintTitleEl && hidePrintTitleEl.value === "true";

        const g_label = document.getElementById("print-label") ? document.getElementById("print-label").innerHTML : "";
        const g_oBeforeBody = document.getElementById("print-report").innerHTML;

        const beforeApprovalEl = document.getElementById("print-approval");
        const g_oBeforeApproval = beforeApprovalEl ? beforeApprovalEl.innerHTML : "";

        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = "";
          if (g_label && isPrint && !hidePrintTitle) {
            document.body.innerHTML += `${g_label}<br>`;
          }
          document.body.innerHTML += `${g_oBeforeBody}<br>${g_oBeforeApproval}`;
        };

        const head = document.head || document.getElementsByTagName("head")[0],
          style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        // 기본 인쇄 스타일과 사용자 정의 스타일 결합
        const defaultPrintCSS = `
          table { 
            page-break-inside: auto; 
            break-inside: auto;
            width: 100% !important;
            border-collapse: collapse !important;
          }
          table tbody tr { 
            page-break-inside: avoid; 
            break-inside: avoid; 
            page-break-after: auto;
          }
          table thead { 
            display: table-header-group; 
          }
          table tbody { 
            display: table-row-group; 
          }
          table thead tr { 
            page-break-inside: avoid; 
            break-inside: avoid; 
          }
        `;

        const combinedCSS = defaultPrintCSS + (css || "");

        if (style.styleSheet) {
          style.styleSheet.cssText = combinedCSS;
        } else {
          style.appendChild(document.createTextNode(combinedCSS));
        }

        head.appendChild(style);

        window.print();
        location.reload();
      }, 300);
    },
    onClickPrint() {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "레이아웃 선택",
          messageIcon: "AlertCircleIcon",
          message: "인쇄 방향을 선택해 주세요.",
          useConfirm: true,
          confirmBtn: "세로 방향",
          cancelBtn: "가로 방향",
          confirmFunction: () => this.printPortrait(),
          cancelFunction: () => this.printLandscape(),
          size: "small",
          btnPosition: "center",
          confirmBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-vertical.svg" },
            style: "",
          },
          cancelBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-horizontal.svg" },
            style: "",
          },
        },
      });
      window.dispatchEvent(customAlert);
    },
    openExcelPopup() {
      this.showExcelPopup = true;

      this.excelList = this.tableData.map((item, index) => {
        return {
          연번: item.oldOrderByNumber,
          소관부서: item.소관부서,
          담당자: item.담당주무관,
          그븐: item.분류,
          시설구분: item.시설구분,
          시설명: item.시설물명,
          "시설위치(사업장주소)": item.주소,
          관리방법: item.관리방법,
          "면적(㎡), 형식, 연장, 차로수, 높이 등": item.면적형식연장등,
          비고: item.비고,
        };
      });
    },

    // 캐시 강제 새로고침
    async refreshData() {
      this.clearCache();
      await this.loadAPI();
    },
    filterButtonInput(data) {
      this.nav.filter = data;
      this.nav.currentPage = 1;
      this.checkList = [];
      this.setTableData();
    },
    // 탭 이동
    moveTab(data) {
      this.nav.currentTab = data;
    },

    // 캐시 키 생성
    generateCacheKey(latestUpdatedAt, totalCount) {
      return `field_list_${this.projectId}_${latestUpdatedAt}_${totalCount}`;
    },

    // 캐시에 데이터 저장
    setCacheData(data, cacheKey) {
      this.cacheData = data;

      // 로컬 스토리지에도 저장
      const cacheInfo = {
        data,
        key: cacheKey,
      };
      idb.setItem(`maot_cache_${this.projectId}`, JSON.stringify(cacheInfo), this.cacheDuration);
    },

    // 캐시 초기화
    clearCache() {
      this.cacheData = null;
      idb.removeItem(`maot_cache_${this.projectId}`);
    },

    // 로컬 스토리지에서 캐시 복원
    restoreCacheFromStorage() {
      try {
        const cached = idb.getItem(`maot_cache_${this.projectId}`);
        if (cached) {
          const cacheInfo = JSON.parse(cached);
          if (Date.now() < cacheInfo.expiry) {
            this.cacheData = cacheInfo.data;
            return true;
          } else {
            idb.removeItem(`maot_cache_${this.projectId}`);
          }
        }
      } catch (error) {
        console.error("캐시 복원 중 오류:", error);
        idb.removeItem(`maot_cache_${this.projectId}`);
      }
      return false;
    },

    // 최신 데이터 정보 조회 (캐시 검증용)
    async getLatestDataInfo() {
      const params = {
        page: 1,
        perPage: 1,
        projectId: this.projectId,
        order_by: "updated_at",
        order_direction: "desc",
      };

      try {
        const response = await this.$store.dispatch("project/LOAD_FIELD_LIST", params);
        const latestData = response.data && response.data[0] ? response.data[0] : null;
        return {
          latestUpdatedAt: latestData && latestData.updated_at ? latestData.updated_at : "",
          totalCount: response.total ? response.total : 0,
        };
      } catch (error) {
        console.error("최신 데이터 정보 조회 실패:", error);
        return { latestUpdatedAt: "", totalCount: 0 };
      }
    },

    async loadOrderByAPI() {
      const params = {
        page: 1,
        perPage: 1,
        projectId: this.projectId,
        boardId: this.orderByBoardId,
        conditions: [{ key: "body.boardId", operator: "=", value: "685/page" }],
        // withMeta: true,
        // metaKeys: [
        //   'body.boardId',
        //   'body.orderByPostIds',
        // ],
        // onlyMeta: true,
      };
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", params);
      if (response.data.length > 0) {
        this.orderByPostId = response.data[0].id;
        const body = JSON.parse(response.data[0].post_content).body;
        this.orderByList = body.orderByPostIds;
      }
    },

    // 모든 데이터 불러오기
    async _loadAPI(page, list) {
      const params = {
        page,
        perPage: 50,
        projectId: this.projectId,
      };
      const _apiData = await this.$store.dispatch("project/LOAD_FIELD_LIST", params);
      list.push(..._apiData.data);
      if (_apiData && Number(_apiData.last_page) >= Number(page)) {
        await this._loadAPI(page + 1, list);
      }
    },
    async loadAPI() {
      this.$vs.loading();

      try {
        // 1. 최신 데이터 정보 먼저 조회 (캐시 키 생성용)
        // console.log('최신 데이터 정보 조회 중...');
        const latestInfo = await this.getLatestDataInfo();
        const latestUpdatedAt = latestInfo && latestInfo.latestUpdatedAt ? latestInfo.latestUpdatedAt : "";
        const totalCount = latestInfo && latestInfo.totalCount ? latestInfo.totalCount : 0;

        const currentCacheKey = this.generateCacheKey(latestUpdatedAt, totalCount);
        // console.log('현재 캐시 키:', currentCacheKey);
        let usedCache = false;

        // 2. 캐싱되어 있는 데이터 있으면 가져오고 없으면 새로 불러오기
        const existingCache = await idb.getItem(`maot_cache_${this.projectId}`);
        if (existingCache) {
          try {
            const cacheInfo = JSON.parse(existingCache);
            // console.log('저장된 캐시 키:', cacheInfo.key);
            // console.log('키 일치 여부:', cacheInfo.key === currentCacheKey);

            if (cacheInfo && cacheInfo.key === currentCacheKey && Array.isArray(cacheInfo.data)) {
              // console.log('유효한 캐시 데이터 사용');
              this.cacheData = cacheInfo.data;
              this.apiData = cacheInfo.data;
              usedCache = true;
            } else {
              // console.log('캐시 무효 - 새로운 데이터 로드 필요');
              this.clearCache();
            }
          } catch (error) {
            console.error("캐시 정보 파싱 오류:", error);
            this.clearCache();
          }
        }

        // 캐시 없으면 새로 로드
        if (!usedCache) {
          const data = [];
          await this._loadAPI(1, data);
          this.apiData = data;
          // 캐시에 저장
          this.setCacheData(data, currentCacheKey);
        }

        // 정렬
        this.apiData.forEach((item) => {
          if (this.orderByList) {
            const findIndex = this.orderByList.indexOf(item.id);
            item.orderByNumber = findIndex > -1 ? findIndex + 1 : 0;
          }
        });

        this.apiData = this.apiData
          .sort((a, b) => {
            const metaA = JSON.parse(a.meta);
            const metaB = JSON.parse(b.meta);

            // orderByNumber 기준 정렬
            const orderA = a.orderByNumber || 0;
            const orderB = b.orderByNumber || 0;
            if (orderA !== orderB) return orderA - orderB;

            const 소관부서 = [
              "기획예산담당관",
              "우주항공과",
              "투자유치산단과",
              "지역경제과",
              "관광정책과",
              "문화예술과",
              "체육진흥과",
              "행정과",
              "회계과",
              "노인장애인과",
              "여성가족과",
              "환경보호과",
              "도로과",
              "녹지공원과",
              "건설과",
              "도시재생과",
              "치매관리과",
              "농축산과",
              "미래농업과",
              "평생학습센터",
              "상하수도사업소",
              "사천읍",
              "정동면",
              "용현면",
              "서포면",
              "동서동",
              "동서금동",
              "벌용동",
              "남양동",
            ];

            const deptA = 소관부서.indexOf(metaA.소관부서);
            const deptB = 소관부서.indexOf(metaB.소관부서);
            if (deptA !== deptB) return deptA - deptB;

            // 시설 분류
            const 분류 = ["공중이용시설", "원료·제조물", "기타"];
            const clsA = 분류.indexOf(this.get시설분류(a));
            const clsB = 분류.indexOf(this.get시설분류(b));
            if (clsA !== clsB) return clsA - clsB;

            // 시설구분
            let 종별A = "기타";
            let 종별B = "기타";

            if (a && a.facility_category && a.facility_category.classification) {
              종별A = a.facility_category.classification;
            }
            if (b && b.facility_category && b.facility_category.classification) {
              종별B = b.facility_category.classification;
            }

            const typeA = this.get시설구분(a, 종별A);
            const typeB = this.get시설구분(b, 종별B);
            if (typeA !== typeB) return String(typeA).localeCompare(String(typeB));

            // 시설명
            return String(a.field_name || "").localeCompare(String(b.field_name || ""));
          })
          .map((item, index) => {
            if (!item.orderByNumber || item.orderByNumber < index + 1) {
              item.orderByNumber = index + 1;
            }
            return item;
          });
        this.setTableData();
      } catch (error) {
        console.error("데이터 로드 중 오류:", error);
        this.$vs.notify({
          title: "오류",
          text: "데이터를 불러오는 중 오류가 발생했습니다.",
          color: "danger",
        });
        this.setTableData();
      } finally {
        this.$vs.loading.close();
      }
    },
    setTableData() {
      this.tableData = [];

      const _filterData = this.apiData.filter((data) => {
        const meta = JSON.parse(data.meta);

        // codes
        if (!this.searchFieldCodes.includes(data.field_type)) return false;

        // 키워드 검색 필터링
        if (this.nav.searchKeyword && this.nav.searchKeyword.trim()) {
          const keyword = this.nav.searchKeyword.trim().toLowerCase();
          const searchFields = [
            data.field_name || "", // 시설물명
            data.address || "", // 주소
            meta.소관부서 || "", // 소관부서
            meta.담당주무관 || "", // 담당주무관
            this.getFieldTypeToString(data.field_type) || "", // 시설구분
            meta.비고 || "", // 비고
          ];

          const hasKeyword = searchFields.some((field) => field.toLowerCase().includes(keyword));

          if (!hasKeyword) return false;
        }

        for (let i = 0; i < this.nav.filter.length; i++) {
          const filter = this.nav.filter[i];

          if (filter.key === "보관자") {
            if ((filter.value && !meta.보관자) || meta.보관자.indexOf(filter.value) < 0) return false;
          } else if (filter.key === "관리방법") {
            if (filter.value.includes("전체")) {
              // 전체인 경우 필터링하지 않음
            } else if (!filter.value.includes(meta.관리방법)) return false;
          } else if (filter.key === "소관부서") {
            if ((filter.value && !meta.소관부서) || meta.소관부서.indexOf(filter.value) < 0) return false;
          } else if (filter.key === "담당주무관") {
            if ((filter.value && !meta.담당주무관) || meta.담당주무관.indexOf(filter.value) < 0) return false;
          }
        }

        return true;
      });

      // 테이블 형식에 맞게 apiData 변형
      this.tableData = _filterData.map((data) => {
        const meta = JSON.parse(data.meta);
        const 종별 = (data.facility_category && data.facility_category.classification) || "기타";
        const _data = {
          분류: this.get시설분류(data),
          시설구분: this.get시설구분(data, 종별),
          시설물명: data.field_name,
          주소: data.address || "-",
          면적형식연장등: this.get면적형식연장등(data),
          적용제외대상: meta.적용제외대상 || "-",
          비고: meta.remarks || "-",
          보관자: meta.보관자,
          관리방법: meta.관리방법,
          소관부서: meta.소관부서,
          담당주무관: meta.담당주무관,
          orderByNumber: data.orderByNumber,
          oldOrderByNumber: data.orderByNumber,
          field_type: data.field_type ? data.field_type : "",
          id: data.id,
          raw: data,
        };
        return _data;
      });
      this.setRenderTableData();
    },
    setRenderTableData() {
      const perPage = this.nav.perPage;

      if (perPage > -1) {
        const datas = this.tableData;
        const _total = Math.ceil(datas.length / perPage);
        this.nav.total = _total < 1 ? 1 : _total;
        const currentPage = this.nav.currentPage;
        const start = (currentPage - 1) * perPage;
        const end = currentPage * perPage;

        this.renderTableData = datas.slice(start, end);
      } else {
        this.renderTableData = this.tableData;
        this.nav.total = 1;
      }
    },
    getFieldTypeToString(type) {
      const keys = Object.keys(this.codes);
      for (const key of keys) {
        if (this.codes[key] === type) return key;
      }
    },
    handleRowClick(row) {
      if (this.editMode) {
        const id = row.id;
        const index = this.checkList.indexOf(id);
        if (index > -1) {
          this.checkList.splice(index, 1);
        } else {
          this.checkList.push(id);
        }
      } else {
        const fieldDataList = this.apiData.filter((data) => data.field_name === row.시설물명);
        if (fieldDataList.length > 0) {
          const fieldType = row.field_type;
          const fieldId = row.id;
          if (!fieldType || !fieldId) return;

          // 페이지 이동
          this.$router.push(`/project/${this.projectId}/field/${fieldType}/write/${fieldId}`);
        } else {
          console.warn("해당 시설물 데이터를 찾을 수 없습니다.");
        }
      }
    },

    get시설분류(data) {
      const 공중이용시설Values = Object.values(this.공중이용시설Codes);
      const 원료제조물Values = Object.values(this.원료제조물Codes);

      if (공중이용시설Values.includes(data.field_type)) {
        return "공중이용시설";
      } else if (원료제조물Values.includes(data.field_type)) {
        return "원료·제조물";
      } else {
        return "기타";
      }
    },

    get시설구분(data, 종별) {
      // 필드 타입을 시설종류(한글)로 변환
      const fieldType = data.field_type;
      const fieldTypeName = this.getFieldTypeToString(fieldType);

      // 시설종류에 따른 분기 처리
      switch (fieldTypeName) {
        case "건축물":
          return "32-건축물";

        case "교량":
          if (data && data.facility_category) {
            const classification = data.facility_category.classification || "";
            // 도로교량
            if (data.facility_category.cat2.includes("도로교량")) {
              if (classification === "1종") return "25-1종 교량";
              if (classification === "2종") return "25-2종 교량";
              if (classification === "3종") return "98-3종 교량";
              // 철도교량
            } else if (data.facility_category.cat2.includes("철도")) {
              if (classification === "1종") return "26-1종 교량";
              if (classification === "2종") return "26-2종 교량";
              if (classification === "3종") return "100-3종 교량";
            }
          }
          return "교량";

        case "도서관":
          return "7-도서관";

        case "둘이상용도건축물":
          return "17-둘이상용도건축물";

        case "박물관 및 미술관":
          return "8-박물관 및 미술관";

        case "복합시설":
          return "17-복합시설";

        case "상수도":
          return "36-상수도";

        case "수도":
        case "소규모수도":
          return "89-수도법";

        case "실내체육시설":
          return "19-실내 체육시설";

        case "실내공연장":
          return "18-실내 공연장";

        case "어린이집":
          return "11-어린이 집";

        case "업무시설":
          return "16-업무시설";

        case "옹벽":
          if (종별 === "1종") return "38-1종 옹벽";
          if (종별 === "2종") return "38-2종 옹벽";
          if (종별 === "3종") return "38-3종 옹벽";
          return "38-옹벽";

        case "의료기관":
          return "9-의료기관";

        case "절토사면":
          if (종별 === "1종") return "38-1종 절토사면";
          if (종별 === "2종") return "38-2종 절토사면";
          if (종별 === "3종") return "38-3종 절토사면";
          return "38-절토사면";

        case "제방":
          return "34-제방";

        case "청사":
          return "16-청사";

        case "터널":
          if (data && data.facility_category) {
            const classification = data.facility_category.classification || "";
            // 도로터널
            if (data.facility_category.cat2.includes("도로")) {
              if (classification === "1종") return "27-1종 터널";
              if (classification === "2종") return "27-2종 터널";
              if (classification === "3종") return "99-3종 터널";
              // 철도터널
            } else if (data.facility_category.cat2.includes("철도")) {
              if (classification === "1종") return "28-1종 터널";
              if (classification === "2종") return "28-2종 터널";
              if (classification === "3종") return "101-3종 터널";
            }
          }
          return "터널";

        case "하수도":
          return "37-하수도";

        case "항만(방파제)":
          return "29-방파제";

        case "항만(부두)":
          return "30-부두";

        case "급식소":
          return "69-식품, 식품첨가물, 기구 및 용기포장(집단급식소)";

        case "먹는물":
          return "90-먹는물 관리법";

        case "승강기":
          return "85-승강기 안전관리법";

        case "식품제조가공업":
          return "69-식품제조가공업";

        case "어린이 놀이시설":
          return "84-어린이 놀이시설 안전관리법";

        default:
          return `${fieldTypeName} - ${종별}`;
      }
    },
    get면적형식연장등(data) {
      const meta = JSON.parse(data.meta);
      const 건축_연면적 = meta.건축_연면적;
      const 층수_최고높이 = meta.층수_최고높이;
      const 연장_길이 = meta.연장_길이;

      // 교량, 터널
      const 차로수_상행 = meta.차로수_상행;
      const 차로수_하행 = meta.차로수_하행;

      // 교량
      const 경간형식 = meta.경간형식;

      // 상수도, 먹는물
      const 시설용량 = meta.시설용량;

      // 옹벽, 절토사면, 터널, 항만(부두)
      const 연장 = meta.연장;
      const 높이 = meta.높이;

      // 제방
      const 제방연장 = meta.제방연장;

      // 터널
      const 주요공법 = meta.주요공법;

      // 하수도
      const 일평균 = meta.일평균;

      // 항만(방파제)
      const 종류 = meta.종류;
      const 허용월파량_호안 = meta.허용월파량_호안;

      // 항만(부두)
      const 대표형식 = meta.대표형식;

      // 급식소
      const 일평균_식수인원 = meta.일평균_식수인원;

      const 기타_상세제원 = meta.기타_상세제원 || meta.otherSpecifications;

      let result = "";
      if (건축_연면적) result += `건축 연면적: ${건축_연면적}, `;
      if (층수_최고높이) result += `층수-최고높이: ${층수_최고높이}, `;
      if (연장_길이) result += `연장-길이: ${연장_길이}, `;
      if (차로수_상행) result += `차로수-상행: ${차로수_상행}, `;
      if (차로수_하행) result += `차로수-하행: ${차로수_하행}, `;
      if (시설용량) result += `시설용량: ${시설용량}, `;
      if (경간형식) result += `경간형식: ${경간형식}, `;
      if (연장) result += `연장: ${연장}, `;
      if (높이) result += `높이: ${높이}, `;
      if (주요공법) result += `주요공법: ${주요공법}, `;
      if (일평균) result += `일평균: ${일평균}, `;
      if (제방연장) result += `제방연장: ${제방연장}, `;
      if (종류) result += `종류: ${종류}, `;
      if (허용월파량_호안) result += `허용월파량(호안): ${허용월파량_호안}, `;
      if (대표형식) result += `대표형식: ${대표형식}, `;
      if (일평균_식수인원) result += `일평균 식수인원: ${일평균_식수인원}, `;
      if (기타_상세제원) result += `기타 상세제원: ${기타_상세제원}, `;
      result = result.slice(0, -2);

      if (result.length === 0) return "-";
      return result;
    },

    /*** 공통: 체크된 index 리스트 구하기 ***/
    getCheckedIndexes() {
      return this.checkList
        .map((id) => this.tableData.findIndex((row) => row.id === id))
        .filter((index) => index !== -1)
        .sort((a, b) => a - b);
    },

    /*** 공통: orderByNumber 재정렬 ***/
    reorderOrderByNumber() {
      this.tableData.forEach((item, idx) => {
        item.orderByNumber = idx + 1;
      });

      this.setRenderTableData();
    },

    /*** ✅ ▼ 한 칸 아래로 ***/
    moveDown() {
      const indexList = this.getCheckedIndexes();
      if (!indexList.length) return;

      // 뒤에서 앞으로(큰 index부터 이동)
      for (let i = indexList.length - 1; i >= 0; i--) {
        let idx = indexList[i];
        if (idx >= this.tableData.length - 1) continue; // 마지막이면 못 내림

        // 묶음 시작 index 찾기
        let groupStart = idx;
        while (i - 1 >= 0 && indexList[i - 1] === groupStart - 1) {
          groupStart--;
          i--;
        }

        const size = idx - groupStart + 1;
        const chunk = this.tableData.splice(groupStart, size);
        this.tableData.splice(groupStart + 1, 0, ...chunk);
      }

      this.reorderOrderByNumber();
    },

    /*** ✅ ▲ 한 칸 위로 ***/
    moveUp() {
      const indexList = this.getCheckedIndexes();
      if (!indexList.length) return;

      // 앞에서 뒤로(작은 index부터 이동)
      for (let i = 0; i < indexList.length; i++) {
        let idx = indexList[i];
        if (idx <= 0) continue; // 첫번째면 못 올림

        // 묶음 끝 index 찾기
        let groupEnd = idx;
        while (i + 1 < indexList.length && indexList[i + 1] === groupEnd + 1) {
          groupEnd++;
          i++;
        }

        const size = groupEnd - idx + 1;
        const chunk = this.tableData.splice(idx, size);

        this.tableData.splice(idx - 1, 0, ...chunk);
      }

      this.reorderOrderByNumber();
    },

    /** 맨 위로 (묶음/개별 모두 내부 순서 유지) */
    moveTop() {
      if (!this.checkList || this.checkList.length === 0) return;

      const sel = new Set(this.checkList);
      const selected = [];
      const others = [];

      // 원래 순서를 유지하면서 분리
      for (const item of this.tableData) {
        (sel.has(item.id) ? selected : others).push(item);
      }

      // ✅ 배열을 재할당하지 말고, in-place 치환
      const newArr = [...selected, ...others];
      if (newArr.length !== this.tableData.length) return; // 방어
      this.tableData.splice(0, this.tableData.length, ...newArr);

      this.reorderOrderByNumber();
    },

    /** 맨 아래로 (묶음/개별 모두 내부 순서 유지) */
    moveBottom() {
      if (!this.checkList || this.checkList.length == 0) return;

      const sel = new Set(this.checkList);
      const selected = [];
      const others = [];

      for (const item of this.tableData) {
        (sel.has(item.id) ? selected : others).push(item);
      }

      const newArr = [...others, ...selected];
      if (newArr.length !== this.tableData.length) return; // 방어
      this.tableData.splice(0, this.tableData.length, ...newArr);

      this.reorderOrderByNumber();
    },

    resetOverByData() {
      this.tableData.sort((a, b) => {
        if (a.oldOrderByNumber < b.oldOrderByNumber) return -1;
        if (a.oldOrderByNumber > b.oldOrderByNumber) return 1;
        return 0;
      });
      this.reorderOrderByNumber();
    },

    cancelOverByData() {
      this.checkList = [];
      this.resetOverByData();
      this.editMode = false;
    },

    async saveOverByData() {
      // tableData 순서를 apiData 에 동기화
      this.syncOrderFromTableToApi();

      const orderByPostIds = this.apiData.map((row) => row.id);
      this.orderByList = orderByPostIds;
      const form = {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          date: new Date().format("yyyy-MM-dd"),
          half: new Date().getMonth() + 1 <= 6 ? "상반기" : "하반기", //반기
          quarter: `${Math.ceil((new Date().getMonth() + 1) / 3)}`, //분기
        },
        body: {
          boardId: "685/page",
          orderByPostIds: orderByPostIds,
        },
      };

      const projectId = this.projectId;
      const boardId = this.orderByBoardId;
      const title = `정렬순서_${projectId}_${boardId}_685/page`;
      const content = JSON.stringify(form);

      if (this.orderByPostId) {
        const postId = this.orderByPostId;
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      } else {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      }
      this.$vs.notify({
        title: "성공",
        text: "정렬 순서가 성공적으로 저장되었습니다.",
        color: "success",
      });

      await this.loadAPI();
    },

    // tableData 순서를 apiData 에 동기화
    syncOrderFromTableToApi() {
      if (!this.apiData.length || !this.tableData.length) return;

      // 1) apiData 를 order 순으로 정렬해 slot 배열 확보
      const apiOrdered = [...this.apiData].sort((a, b) => a.orderByNumber - b.orderByNumber);

      // 2) tableData 의 id 추출
      const filteredIds = this.tableData.map((item) => item.id);
      const filteredIdSet = new Set(filteredIds);

      // 3) apiData 에서 tableData 에 해당하는 row 들의 '원래 slot index' 찾기
      const slots = [];
      apiOrdered.forEach((item, idx) => {
        if (filteredIdSet.has(item.id)) slots.push(idx);
      });

      // 4) 현재 tableData 순서대로 raw 객체를 준비
      const reorderedChunk = this.tableData.map((row) => row.raw);

      // 5) 원래 slot 위치에 tableData 순서대로 다시 꽂아 넣는다
      slots.forEach((slotIndex, i) => {
        apiOrdered[slotIndex] = reorderedChunk[i];
      });

      // 6) 전체 원본 apiData 의 orderByNumber 재정렬
      apiOrdered.forEach((row, index) => {
        row.orderByNumber = index + 1;
      });

      // 7) apiData 업데이트 (반응성 유지)
      this.apiData.splice(0, this.apiData.length, ...apiOrdered);
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 6px;
  }

  th {
    font-weight: 500;
    background: #fafafa;
    padding: 18px 0;
  }

  tbody tr {
    cursor: pointer;

    &:hover {
      background-color: #f0f0f0;
    }
  }
}

.active {
  background-color: #f0f0f0;
}

@media print {
  table {
    page-break-inside: auto;
    break-inside: auto;

    tbody tr {
      page-break-inside: avoid;
      break-inside: avoid;
      page-break-after: auto;

      &:hover {
        background-color: inherit;
      }
    }

    thead {
      display: table-header-group;
    }

    tbody {
      display: table-row-group;
    }
  }

  // 페이지 여백 설정
  @page {
    margin: 1cm;
    size: A4;
  }

  // 테이블이 페이지를 넘어갈 때 헤더 반복
  thead tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
</style>
